interface AboutLcHeroProps {
  label: string
  bodyLine1: string
  bodyLine2: string
  emphasis: string
  ctaLabel: string
  onCtaClick: () => void
  imageUrl: string
  imageUrlMobile: string
  imageAlt: string
}

export function AboutLcHero({
  label,
  bodyLine1,
  bodyLine2,
  emphasis,
  ctaLabel,
  onCtaClick,
  imageUrl,
  imageUrlMobile,
  imageAlt,
}: AboutLcHeroProps) {
  return (
    <section id="hero" data-marketing-section="" className="w-full bg-qb-bg">
      <div className="flex flex-col items-center pt-10 lg:pt-20 px-6 lg:px-10 gap-10 lg:gap-20">
        {/* Title block — gap 16 mobile / 24 desktop */}
        <div className="flex flex-col items-center gap-4 lg:gap-6 text-center tracking-[-0.6px]">
          <p className="font-bold text-qb-primary text-[16px] lg:text-[24px] leading-[1.5] lg:leading-[1.4]">
            {label}
          </p>
          <div className="font-medium text-qb-text-high text-[20px] lg:text-[36px] leading-[1.5] lg:leading-[1.2]">
            <p>{bodyLine1}</p>
            <p>{bodyLine2}</p>
          </div>
          <p className="font-bold lg:font-extrabold text-qb-text-high text-[32px] lg:text-[56px] leading-[1.4] lg:leading-[1.2]">
            {emphasis}
          </p>
        </div>

        {/* CTA — pill button */}
        <button
          type="button"
          onClick={onCtaClick}
          className="marketing-cta bg-qb-primary text-white h-12 lg:h-14 px-6 rounded-full font-medium lg:font-semibold text-[18px] lg:text-[20px] leading-[1.5] tracking-[-0.6px] shadow-[0px_4px_4px_rgba(0,0,0,0.1)] hover:bg-qb-primary-hover active:bg-qb-primary-pressed transition-colors whitespace-nowrap"
        >
          {ctaLabel}
        </button>
      </div>

      {/* Hero image — full bleed bottom (mobile image is 1221×280, extends past viewport) */}
      <div className="mt-10 lg:mt-20 w-full overflow-hidden bg-white">
        <picture className="block w-full">
          <source media="(min-width: 1024px)" srcSet={imageUrl} />
          <img
            src={imageUrlMobile}
            alt={imageAlt}
            className="w-full h-[280px] lg:h-[440px] object-cover object-bottom"
          />
        </picture>
      </div>
    </section>
  )
}
